"use client";

import React, { useState } from "react";
import { useForm, ValidationError } from "@formspree/react";
import Image from "next/image";

const translations = {
  en: {
    contact: {
      title: "Get in Touch with Us",
      description:
        "Have questions or need assistance? Provide your details, and our team will reach out to you promptly. We're here to help!",
      fullName: "Full Name",
      email: "Email",
      companyName: "Company Name",
      messagePlaceholder: "Your message here...",
      sending: "Sending...",
      submit: "CONTACT US",
      successMessage: "Message Successfully Sent!",
    },
  },
  tr: {
    contact: {
      title: "BİZİMLE İETLİŞİME GEÇİN",
      description:
        "Sorularınız mı var? Ekibimiz sizinle en kısa sürede iletişime geçecektir! Yardım etmek için buradayız!",
      fullName: "Ad Soyad",
      email: "E-posta",
      companyName: "Şirket Adı",
      messagePlaceholder: "Mesajınızı buraya yazın...",
      sending: "Gönderiliyor...",
      submit: "BİZE ULAŞIN",
      successMessage: "Mesaj Başarıyla Gönderildi!",
    },
  },
};


export default function ContactPage() {
  const [state, handleSubmit] = useForm("xnnqynrd"); // Replace with your Formspree form ID
  const [fullName, setFullName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [messageContent, setMessageContent] = useState("");
  const [language, setLanguage] = useState<"en" | "tr">("en"); // Explicit type

  // Initialize language from localStorage
  React.useEffect(() => {
    const storedLanguage = localStorage.getItem("selectedLanguage");
    if (storedLanguage === "en" || storedLanguage === "tr") {
      setLanguage(storedLanguage);
    }
  }, []);

  const t = translations[language]; // Get translations for selected language

  // Reset form fields after successful submission
  React.useEffect(() => {
    if (state.succeeded) {
      setFullName("");
      setCompanyName("");
      setMessageContent("");
    }
  }, [state.succeeded]);

  return (
    <div className="w-full flex md:px-40 md:py-16 px-8 text-brown-800 md:mt-10 md:flex-row flex-col mt-16">
      <div className="md:w-1/2 flex">
       <Image
  src="https://i.ibb.co/hZRyF8M/Asset-4.png"
  alt="Contact Us"
  width={500}
  height={300}
  className="m-auto"
  unoptimized // Removes Next.js optimizations (for debugging)
 />

      </div>
      <div className="md:w-1/2 text-brown-800 flex flex-col mt-16 md:mt-0 mb-8 md:mb-0 my-auto justify-center">
        <h1 className="text-3xl uppercase font-[600]">{t.contact.title}</h1>
        <p className="mt-2 text-sm text-brown-400">{t.contact.description}</p>
        <form
          onSubmit={handleSubmit}
          className="flex flex-col mt-10 rounded gap-5 text-brown-000 font-[400]"
        >
          <input
            type="text"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            placeholder={t.contact.fullName}
            name="fullName"
            className="bg-brown-500 border-b-2 border-brown-800 outline-none py-2 px-5 rounded placeholder-brown-200"
          />
          <ValidationError prefix="Full Name" field="fullName" errors={state.errors} />
          <input
            type="email"
            name="email"
            placeholder={t.contact.email}
            className="bg-brown-500 border-b-2 border-brown-800 outline-none py-2 px-5 rounded placeholder-brown-200"
          />
          <ValidationError prefix="Email" field="email" errors={state.errors} />
          <input
            type="text"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            placeholder={t.contact.companyName}
            name="companyName"
            className="bg-brown-500 border-b-2 border-brown-800 outline-none py-2 px-5 rounded placeholder-brown-200"
          />
          <ValidationError prefix="Company Name" field="companyName" errors={state.errors} />
          <textarea
            value={messageContent}
            onChange={(e) => setMessageContent(e.target.value)}
            placeholder={t.contact.messagePlaceholder}
            name="message"
            className="bg-brown-500 border-b-2 border-brown-800 outline-none py-2 px-5 rounded placeholder-brown-200 resize-none h-40"
          ></textarea>
          <ValidationError prefix="Message" field="message" errors={state.errors} />

          {/* Conditional rendering of success message */}
          {state.succeeded && (
            <p className="text-green-600 text-center font-medium">{t.contact.successMessage}</p>
          )}

          <button
            type="submit"
            disabled={state.submitting}
            className="bg-brown-700 text-brown-000 md:w-1/2 py-2 rounded-sm font-[500] hover:bg-brown-600 duration-200 border-brown-100 placeholder-brown-200 m-auto px-10"
          >
            {state.submitting ? t.contact.sending : t.contact.submit}
          </button>
        </form>
      </div>
    </div>
  );
}
